import { useEffect, useState, useRef } from "react";
import { useDispatch } from "react-redux";
import FooterActions from "./AssignBuildingFooter";
import HeaderBreadCrumb from "./AssignBuildingHeader";
import { Button } from "primereact/button"; // Import Button

import { contractSchema } from "../../schemas/contractSchema";
import FileDownloadIcon from "@mui/icons-material/FileDownload";

import "./AssignBuilding.scss";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import { contractInitialState } from "src/state/contractInitialState";
import { Calendar } from "primereact/calendar";
import {
  convertIsoStringToDate,
  formatDateV2,
  downloadFile,
  getFieldName,
  scrollToTopWithClass,
  isNullOrWhiteSpace,
  convertToISO,
} from "src/utils/helpers";
import {
  setContractInfo,
  validateContractNumberUniqueness,
} from "src/redux/slices/assignBuildingSlice";
import { toast } from "react-toastify";
import { Dropdown } from "primereact/dropdown";
import CloseIcon from "@mui/icons-material/Close";
import moment from "moment";
import FileUploader from "../FileUploader/FileUploader";
import _ from "lodash";
import AssignBuildingTitle from "./AssignBuildingTitle";
import { ALLOWED_FILES_EXTENSION } from "src/resources/constant";
import { FileUpload } from "primereact/fileupload";
import { onHideCalendar, onShowCalendar } from "src/utils/common";

const BuildingContract = () => {
  const dispatch = useDispatch();
  const { t } = useTranslation(["common", "assignBuilding"]);
  const contractDetails = useSelector(
    (state: any) => state.assignBuilding.contractInfo
  );
  const fileUploadRef = useRef<FileUpload>(null);
  const { isNewMode, isContractPopupOpened, originalAppointments } =
    useSelector((state: any) => state.assignBuilding);

  const contractTypes = useSelector((state: any) => state.lookup.contractTypes);
  const language = useSelector((state: any) => state.lookup.language);

  const civilDefenseContractApprovalStatuses = useSelector(
    (state: any) => state.lookup.civilDefenseContractApprovalStatuses
  );
  const [preventiveDates, setPreventiveDates] = useState<any>(
    contractDetails.preventiveDates
  );

  const [isNextButtonClicked, setIsNextButtonClicked] = useState<any>(false);
  const [selectedDate, setSelectedDate] = useState<any>(null);
  const [viewDate, setViewDate] = useState<Date | null>(null);

  const startDateRef = useRef<Calendar | null>(null);
  const endDateRef = useRef<Calendar | null>(null);
  const appointmentDatesRef = useRef<Calendar | null>(null);

  const handleSubmission = () => {
    console.log("handleSubmission");
  };
  const [errors, setErrors] = useState(contractInitialState);
  const [isContractNumberExistsBefore, setIsContractNumberExistsBefore] =
    useState(false);

  const isValidInput = (data: any) => {
    const error = validateSchema(data);
    if (error) return false;
    else {
      return true;
    }
  };

  const validateSchema = (data: any) => {
    const { error } = contractSchema(data).validate(data, {
      abortEarly: false,
    });
    if (error) {
      const newErrors: any = {};
      error.details.forEach((err: any) => {
        newErrors[err.context?.key] = err.message;
      });
      console.log({ newErrors });
      setErrors(newErrors);
    } else {
      setErrors(contractInitialState);
    }
    return error;
  };
  function scrollUp() {
    const className = "invalid-input";
    const parentClass = "p-dialog-content";
    scrollToTopWithClass(className, parentClass);
  }
  useEffect(() => {
    if (!_.isEqual(errors, contractInitialState)) {
      scrollUp();
    }
  }, [errors]);

  useEffect(() => {
    if (isNextButtonClicked) validateSchema(contractDetails);
  }, [language]);

  const handleFileChange = (event: any) => {
    const file = event.files[0];
    if (file) {
      const fileExtension = file.name.split(".").pop();
      if (ALLOWED_FILES_EXTENSION.includes(fileExtension.toLowerCase())) {
        const reader = new FileReader();
        reader.onloadend = () => {
          const fileObject = {
            fileName: file.name,
            fileExtension,
            fileBase64: reader.result as string,
            subject: "contract",
          };
          // fileObject.fileBase64 = fileObject.fileBase64.replace(
          //   /^data:.*;base64,/,
          //   ""
          // ); // this string makes issue on CRM while open the file
          const updatedContractDetails = {
            ...contractDetails,
            amcCopy: fileObject,
          };
          dispatch(setContractInfo(updatedContractDetails));
          if (isNextButtonClicked) validateSchema(updatedContractDetails);
        };
        reader.readAsDataURL(file);
      } else {
        toast.error(t("validFileExtension"));
      }
    }
  };

  const nextClicked = () => {
    setIsNextButtonClicked(true);
    if (isContractNumberExistsBefore) {
      toast.error(t("contractUniqueErrorMsg"));
      return false;
    }
    // console.log("next Clicked");
    // console.log("contractDetails", contractDetails);
    const updatedContractDetails = {
      ...contractDetails,
      isNew: isNewMode,
      preventiveDates: preventiveDates,
    };
    dispatch(setContractInfo(updatedContractDetails));

    const isValid = isValidInput(updatedContractDetails);
    if (isValid) {
      if (preventiveDates.length === 0 || preventiveDates.length < 4) {
        toast.error(t("appointmentsValidation"));
        return false;
      }

      var startDate = moment(contractDetails.startDate);
      var endDate = moment(contractDetails.endDate);
      if (startDate.isAfter(endDate)) {
        toast.error(t("startEndDateValidation"));
        return false;
      }

      if (preventiveDates) {
        var index;
        for (index in preventiveDates) {
          {
            if (!validateDate(startDate, endDate, preventiveDates[index]))
              return false;
          }
        }
      }

      handleSubmission();
    } else {
      scrollUp();
    }
    return isValid;
  };

  const backClicked = () => {
    const updatedContractDetails = {
      ...contractDetails,
      preventiveDates: preventiveDates,
    };
    dispatch(setContractInfo(updatedContractDetails));
  };

  const getMaxEndDate = (): Date | undefined => {
    if (contractDetails.startDate) {
      const startDate = convertIsoStringToDate(
        contractDetails.startDate.toString()
      );
      const endDate = new Date(startDate);
      endDate.setFullYear(endDate.getFullYear() + 1);
      return endDate;
    }
  };
  const getMinEndDate = (): Date | undefined => {
    if (contractDetails.startDate) {
      const minDate = convertIsoStringToDate(contractDetails.startDate);
      minDate.setDate(minDate.getDate() + 3);
      return minDate;
    }
  };

  const getMinAppointmentsEndDate = (): Date | undefined => {
    if (contractDetails.startDate) {
      const minDate = convertIsoStringToDate(contractDetails.startDate);

      return minDate;
    }
  };
  const getMaxAppointmentsEndDate = (): Date | undefined => {
    if (contractDetails.endDate) {
      return convertIsoStringToDate(contractDetails.endDate);
    }
  };
  const getMinStartDate = (): Date | undefined => {
    if (contractDetails.endDate) {
      const endDate = convertIsoStringToDate(
        contractDetails.endDate.toString()
      );
      const startDate = new Date(endDate);
      startDate.setFullYear(startDate.getFullYear() - 1);
      return startDate;
    }
  };
  const getMaxStartDate = (): Date | undefined => {
    if (contractDetails.endDate) {
      const endDate = convertIsoStringToDate(
        contractDetails.endDate.toString()
      );
      const startDate = new Date(endDate.setFullYear(endDate.getFullYear()));
      startDate.setDate(startDate.getDate() - 3);
      return startDate;
    }
  };
  const handleChange = (event: any): void => {
    let name = "",
      value;
    if (event?.originalEvent?.target?.inputMode === "numeric") {
      value = event.value.toString();
      name = event.originalEvent.target.name;
    } else {
      value = event.target.value;
      name = event.target.name;
    }
    if (name === "startDate" || name === "endDate") {
      if (value !== null) {
        const isoDate = convertToISO(value);
        value = moment(isoDate).format("YYYY-MM-DDTHH:mm:ss[Z]");
      }
    }
    const updatedContractDetails = { ...contractDetails, [name]: value };
    dispatch(setContractInfo(updatedContractDetails));

    //validate on specific props
    if (updatedContractDetails.startDate && updatedContractDetails.endDate) {
      const startDate = moment(contractDetails.startDate);
      const endDate = moment(contractDetails.endDate);
      if (startDate.isAfter(endDate)) {
        toast.error(t("startEndDateValidation"));
        const updatedContractDetails = {
          ...contractDetails,
          ["endDate"]: null,
        };
        dispatch(setContractInfo(updatedContractDetails));
      }
    }

    //validate if contract number exists before or no

    if (isNextButtonClicked) validateSchema(updatedContractDetails);
  };

  function isAfter(date1: any, date2: any): boolean {
    var startDate = moment(date1);
    var endDate = moment(date2);
    if (startDate.isAfter(endDate, "day")) {
      return true;
    }
    return false;
  }

  function validateDate(
    startDate: any,
    endDate: any,
    selectedDate: any
  ): boolean {
    if (isAfter(startDate, selectedDate) || isAfter(selectedDate, endDate)) {
      toast.error(t("appointmentDateAndContractDatesValidation"));
      return false;
    }
    return true;
  }

  const handleSelectedDate = (e: any): void => {
    setSelectedDate(e.target.value);
  };

  const handleAppointmentDatesSelection = (e: any): void => {
    if (!selectedDate) {
      toast.error(t("selectValidDateValidation"));
      return;
    }

    if (!contractDetails.startDate || !contractDetails.endDate) {
      toast.error(t("contractDatesFirstValidation"));
      return;
    }

    const parsedDate = moment(selectedDate);
    const formattedPreventiveDates = preventiveDates.map((d: string) =>
      moment(convertToISO(d)).format("YYYY-MM-DD")
    );
    const formattedParsedDate = moment(selectedDate).format("YYYY-MM-DD");
    if (formattedPreventiveDates.includes(formattedParsedDate)) {
      toast.error(t("addedBeforeValidation"));
      return;
    }

    let startDate = contractDetails.startDate;
    let endDate = contractDetails.endDate;

    if (validateDate(startDate, endDate, parsedDate)) {
      setPreventiveDates((prev: any) => [...prev, parsedDate?.toString()]);
      setSelectedDate(null);
      setViewDate(selectedDate);
    } else return;
  };

  const handleRemoveAppointmentDates = (appointment: any): void => {
    const today = new Date();
    let selectedDate = new Date(appointment);
    if (
      !isNewMode &&
      isAfter(today, selectedDate) &&
      originalAppointments.includes(appointment)
    ) {
      toast.error(t("pastDatesValidations"));
      return;
    }
    setPreventiveDates((prev: any) =>
      prev.filter((se: any) => se !== appointment)
    );
  };
  const isValidPreventiveDates = () => {
    return preventiveDates?.length < 4 && isNextButtonClicked;
  };

  const checkIsContractNumberUnique = async () => {
    const resData = await dispatch(
      validateContractNumberUniqueness(contractDetails.amcContractNumber) as any
    );
    if (resData.data?.ErrorCode == "0") {
      setIsContractNumberExistsBefore(false);
    } else {
      setIsContractNumberExistsBefore(true);
    }

    return resData.data;
  };

  return (
    <>
      {!isContractPopupOpened && <AssignBuildingTitle />}
      <HeaderBreadCrumb></HeaderBreadCrumb>
      <h1 className="text-center m-auto">{t("contractInfo")}</h1>
      <div className="registration-form-wrapper assign-form-wrapper">
        <div className="registration-form building-details-form">
          <div className="building-details-form__content">
            <div className="form-group-row">
              <div className={`form-group  ${!isNewMode ? "disabled" : ""}`}>
                <label htmlFor="amcContractNumber" className="required">
                  {t("amcContractNo")}:
                </label>
                <input
                  id="amcContractNumber"
                  name="amcContractNumber"
                  onChange={handleChange}
                  disabled={!isNewMode}
                  value={contractDetails.amcContractNumber}
                  required
                  className={`${
                    errors.amcContractNumber || isContractNumberExistsBefore
                      ? "invalid-input"
                      : ""
                  }`}
                  onBlur={async () => {
                    if (
                      !isNullOrWhiteSpace(contractDetails.amcContractNumber)
                    ) {
                      await checkIsContractNumberUnique();
                    }
                  }}
                />
                {errors.amcContractNumber && (
                  <p className="error">{errors.amcContractNumber}</p>
                )}
                {isContractNumberExistsBefore && (
                  <p className="error">{t("contractUniqueErrorMsg")}</p>
                )}
              </div>
              <div className={`form-group  ${!isNewMode ? "disabled" : ""}`}>
                <label htmlFor="contractTypeId">{t("contractType")}:</label>
                <Dropdown
                  id="contractTypeId"
                  name="contractTypeId"
                  value={contractDetails.contractTypeId?.toString()}
                  options={contractTypes}
                  optionValue={"id"}
                  optionLabel={getFieldName(language)}
                  disabled={!isNewMode}
                  onChange={handleChange}
                  required
                  className={`${errors.contractTypeId ? "invalid-input" : ""}`}
                  placeholder={t("selectContractType")}
                />
                {errors.contractTypeId && (
                  <span className="error">{errors.contractTypeId}</span>
                )}
              </div>
              <div className={`form-group  ${!isNewMode ? "disabled" : ""}`}>
                <label htmlFor="startDate" className="required">
                  {t("startDate")}:
                </label>
                <Calendar
                  id="startDate"
                  value={
                    contractDetails?.startDate
                      ? convertIsoStringToDate(contractDetails?.startDate)
                      : null
                  }
                  name="startDate"
                  disabled={!isNewMode}
                  onChange={handleChange}
                  dateFormat="dd/mm/yy"
                  placeholder="DD/MM/YYYY"
                  showIcon
                  minDate={getMinStartDate()}
                  maxDate={getMaxStartDate()}
                  required
                  className={`${errors.startDate ? "invalid-input" : ""}`}
                  ref={startDateRef}
                  onHide={() => onHideCalendar(startDateRef)}
                  onShow={() => onShowCalendar(startDateRef)}
                  key={`startDate-${contractDetails?.startDate?.toString()}`}
                />
                {errors.startDate && (
                  <p className="error">{errors.startDate}</p>
                )}
              </div>
              <div className={`form-group  ${!isNewMode ? "disabled" : ""}`}>
                <label htmlFor="endDate" className="required">
                  {t("endDate")}:
                </label>
                <Calendar
                  id="endDate"
                  value={
                    contractDetails?.endDate
                      ? convertIsoStringToDate(contractDetails?.endDate)
                      : null
                  }
                  name="endDate"
                  disabled={!isNewMode}
                  onChange={handleChange}
                  dateFormat="dd/mm/yy"
                  placeholder="DD/MM/YYYY"
                  showIcon
                  minDate={getMinEndDate()}
                  maxDate={getMaxEndDate()}
                  required
                  className={`${errors.endDate ? "invalid-input" : ""}`}
                  ref={endDateRef}
                  onHide={() => onHideCalendar(endDateRef)}
                  onShow={() => onShowCalendar(endDateRef)}
                  key={`endDate-${contractDetails?.endDate?.toString()}`}
                />
                {errors.endDate && <p className="error">{errors.endDate}</p>}
              </div>
              <div className="form-group">
                <label
                  htmlFor="civilDefenseContractApprovalStatusId"
                  className="required"
                >
                  {t("civilDefenseContractApprovalStatus")}:
                </label>
                <Dropdown
                  id="civilDefenseContractApprovalStatusId"
                  value={contractDetails.civilDefenseContractApprovalStatusId?.toString()}
                  name="civilDefenseContractApprovalStatusId"
                  onChange={handleChange}
                  options={civilDefenseContractApprovalStatuses}
                  optionValue={"id"}
                  optionLabel={getFieldName(language)}
                  placeholder={t("selectStatus")}
                  className={`${
                    errors.civilDefenseContractApprovalStatusId
                      ? "invalid-input"
                      : ""
                  }`}
                  required
                />
                {errors.civilDefenseContractApprovalStatusId && (
                  <span className="error">
                    {errors.civilDefenseContractApprovalStatusId}
                  </span>
                )}
              </div>
              <div className="form-group">
                <label htmlFor="amcCopy">{t("amcCopy")}</label>
                {!isNewMode && contractDetails.amcCopy?.fileName && (
                  <div className="mb-1">
                    {contractDetails.amcCopy?.fileName}
                    <Button
                      className="m-0 p-0 ms-2 download-btn"
                      text
                      onClick={() =>
                        downloadFile(
                          contractDetails.amcCopy,
                          t("fileSizeExceeds")
                        )
                      }
                    >
                      <FileDownloadIcon />{" "}
                    </Button>
                  </div>
                )}
                <FileUploader
                  fileUploadRef={fileUploadRef}
                  id="amcCopy"
                  name="amcCopy"
                  onChange={handleFileChange}
                  disabled={false}
                  className={`${errors.amcCopy ? "invalid-input" : ""}`}
                  fileName={contractDetails.amcCopy?.fileName || ""}
                />

                <div className="file-footer d-flex flex-column w-100">
                  {errors.amcCopy ? (
                    <p className="error">{errors.amcCopy}</p>
                  ) : (
                    <p className="note">{t("fileSizeAndTypeNote")}</p>
                  )}
                </div>
              </div>
            </div>
            <div className="form-group-row">
              <div className="form-group">
                <label htmlFor="appointmentDates" className="required">
                  {t("appointmentDates")}:
                </label>
                <Calendar
                  id="appointmentDates"
                  name="appointmentDates"
                  dateFormat="dd/mm/yy"
                  placeholder="DD/MM/YYYY"
                  value={selectedDate}
                  onChange={handleSelectedDate}
                  viewDate={viewDate}
                  showIcon
                  minDate={getMinAppointmentsEndDate()}
                  maxDate={getMaxAppointmentsEndDate()}
                  required
                  className={`${
                    isValidPreventiveDates() ? "invalid-input" : ""
                  }`}
                  ref={appointmentDatesRef}
                  onHide={() => onHideCalendar(appointmentDatesRef)}
                  onShow={() => onShowCalendar(appointmentDatesRef)}
                  key={`appointmentDates-${selectedDate?.toString()}`}
                />
              </div>
              <div className="form-group mt-2">
                <Button
                  className="light-primary-btn mt-3 d-flex gap-2"
                  onClick={handleAppointmentDatesSelection}
                >
                  <span className="system-btn contact">+</span>
                  <span>{t("selectAppointments")}</span>
                </Button>
              </div>
              {isValidPreventiveDates() ? (
                <span className="error">{t("appointmentsValidation")}</span>
              ) : (
                <></>
              )}
            </div>
            <div className="date-tags d-flex justify-content-start gap-2 mt-4 mb-5 flex-wrap">
              {preventiveDates.map((date: any, index: number) => (
                <div key={date} className="date-tag plain-text-date">
                  {formatDateV2(date)}
                  <CloseIcon
                    onClick={() => handleRemoveAppointmentDates(date)}
                    className="cursor-pointer ms-1"
                  />
                </div>
              ))}
            </div>

            <div className="form-group-row">
              <div className="form-group">
                <label htmlFor="engineerTechnicianName" className="required">
                  {t("engineerTechnicianName")}:
                </label>
                <input
                  type="text"
                  id="engineerTechnicianName"
                  name="engineerTechnicianName"
                  onChange={handleChange}
                  value={contractDetails.engineerTechnicianName}
                  required
                  className={`${
                    errors.engineerTechnicianName ? "invalid-input" : ""
                  }`}
                />
                {errors.engineerTechnicianName && (
                  <p className="error">{errors.engineerTechnicianName}</p>
                )}
              </div>
              <div className="form-group">
                <label htmlFor="technicianMobileNumber" className="required">
                  {t("technicianMobileNumber")}:
                </label>
                <div className="form-group input-with-label">
                  <span className="ltr">+971</span>
                  <input
                    type="text"
                    id="technicianMobileNumber"
                    onChange={handleChange}
                    name="technicianMobileNumber"
                    value={contractDetails.technicianMobileNumber}
                    required
                    className={`${
                      errors.technicianMobileNumber ? "invalid-input" : ""
                    }`}
                  />
                </div>
                {errors.technicianMobileNumber && (
                  <p className="error">{errors.technicianMobileNumber}</p>
                )}
              </div>
            </div>
            <div className="form-group-row">
              <div className="form-group">
                <label htmlFor="technicianEmail" className="required">
                  {t("technicianEmail")}:
                </label>
                <input
                  type="text"
                  id="technicianEmail"
                  onChange={handleChange}
                  name="technicianEmail"
                  value={contractDetails.technicianEmail}
                  required
                  className={`${errors.technicianEmail ? "invalid-input" : ""}`}
                />
                {errors.technicianEmail && (
                  <p className="error">{errors.technicianEmail}</p>
                )}
              </div>
              <div className="form-group">
                <label htmlFor="technicianAlternateNumber">
                  {t("technicianAlternateNumber")}:
                </label>
                <div className="form-group input-with-label">
                  <span className="ltr">+971</span>
                  <input
                    type="text"
                    id="technicianAlternateNumber"
                    onChange={handleChange}
                    name="technicianAlternateNumber"
                    value={contractDetails?.technicianAlternateNumber}
                    className={`${
                      errors.technicianAlternateNumber ? "invalid-input" : ""
                    }`}
                  />
                </div>
                {errors.technicianAlternateNumber && (
                  <p className="error">{errors.technicianAlternateNumber}</p>
                )}
              </div>
            </div>
            <div className="form-group-row">
              <div className="form-group">
                <label htmlFor="managerSupervisorName" className="required">
                  {t("managerSupervisorName")}:
                </label>
                <input
                  type="text"
                  id="managerSupervisorName"
                  onChange={handleChange}
                  name="managerSupervisorName"
                  value={contractDetails.managerSupervisorName}
                  required
                  className={`${
                    errors.managerSupervisorName ? "invalid-input" : ""
                  }`}
                />
                {errors.managerSupervisorName && (
                  <p className="error">{errors.managerSupervisorName}</p>
                )}
              </div>
              <div className="form-group">
                <label htmlFor="managerMobileNumber" className="required">
                  {t("technicianMobileNumber")}:
                </label>
                <div className="form-group input-with-label">
                  <span className="ltr">+971</span>
                  <input
                    type="text"
                    id="managerMobileNumber"
                    onChange={handleChange}
                    name="managerMobileNumber"
                    value={contractDetails.managerMobileNumber}
                    required
                    className={`${
                      errors.managerMobileNumber ? "invalid-input" : ""
                    }`}
                  />
                </div>
                {errors.managerMobileNumber && (
                  <p className="error">{errors.managerMobileNumber}</p>
                )}
              </div>
            </div>
            <div className="form-group-row">
              <div className="form-group">
                <label htmlFor="managerEmail" className="required">
                  {t("technicianEmail")}:
                </label>
                <input
                  type="text"
                  id="managerEmail"
                  onChange={handleChange}
                  name="managerEmail"
                  value={contractDetails.managerEmail}
                  required
                  className={`${errors.managerEmail ? "invalid-input" : ""}`}
                />
                {errors.managerEmail && (
                  <p className="error">{errors.managerEmail}</p>
                )}
              </div>
              <div className="form-group">
                <label htmlFor="managerAlternateNumber">
                  {t("technicianAlternateNumber")}:
                </label>
                <div className="form-group input-with-label">
                  <span className="ltr">+971</span>
                  <input
                    type="text"
                    id="managerAlternateNumber"
                    onChange={handleChange}
                    name="managerAlternateNumber"
                    value={contractDetails?.managerAlternateNumber}
                    className={`${
                      errors.managerAlternateNumber ? "invalid-input" : ""
                    }`}
                  />
                </div>
                {errors.managerAlternateNumber && (
                  <p className="error">{errors.managerAlternateNumber}</p>
                )}
              </div>
            </div>
          </div>

          {
            <FooterActions
              contractDetails={contractDetails}
              current={"contract"}
              previous={"buildingDetails"}
              nextPage={"systems"}
              onNextClick={nextClicked}
              onBackClick={backClicked}
              isEditMode={!isNewMode}
            ></FooterActions>
          }
        </div>
      </div>
    </>
  );
};

export default BuildingContract;
